package tta.destinigo.talktoastro.feature_expert_listing.expert_list_page.expert_list_state_info


sealed class MarkFeavoriteState {
    data class Loading(val isLoading:Boolean) : MarkFeavoriteState()
    data class Error(val message: String?) : MarkFeavoriteState()
    data class Success(val status: String): MarkFeavoriteState()
}